import React from "react";
import { DeprecatedUISharedButton } from "packages/ui-shared/components/Button/Button";
import { useSegment } from "tracking";
import { addBasketItems, getMembershipWithId } from "lib/api";
import type { ItemType, VariantType } from "@shared/graphql.types";
import { useCurrencySymbol, useFreeTrial, useUserV2 } from "hooks";
import { drawerBtn, drawerCFooter, drawerBtnText } from "./Drawer.css";

type Props = {
  onClose: () => void;
  variantData: [
    id: VariantType["id"],
    sku: VariantType["sku"],
    pricing: VariantType["pricing"]
  ];
};

export const DrawerFooter: React.FC<Props> = ({ onClose, variantData }) => {
  const { track } = useSegment();

  const { freeTrialMembershipId } = useFreeTrial();
  const { hasMembership } = useUserV2();
  const currencySymbol = useCurrencySymbol();

  const [variantId, variantSku, pricing] = variantData;

  const membership = getMembershipWithId(freeTrialMembershipId);

  const item = {
    quantity: 1,
    variantId,
    variantSku,
    type: "product",
    origin: "user"
  } as unknown as ItemType;

  const handleButtonClick = async () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "dupes_v3_drawer",
        module_content_details: "add_to_bag",
        location_type: "dupes_v3_drawer",
        module_content_details2: variantSku
      }
    });

    const itemsToAdd = [item];
    if (!hasMembership) {
      itemsToAdd.push(membership);
    }
    await addBasketItems(itemsToAdd);
    onClose();
  };

  return (
    <div className={drawerCFooter}>
      <div data-testid="drawer-btn">
        <DeprecatedUISharedButton
          variant="primary"
          className={drawerBtn}
          handleClick={handleButtonClick}
        >
          <div className={drawerBtnText}>
            Add To Bag {` `}{" "}
            <span style={{ textDecoration: "line-through" }}>
              {currencySymbol}
              {pricing.typical}
            </span>{" "}
            {currencySymbol}
            {pricing.members}
          </div>
        </DeprecatedUISharedButton>
      </div>
    </div>
  );
};
